var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { hide: _vm.loading },
    },
    [
      _c("cms-heading", { attrs: { title: _vm.pageTitle } }),
      _c(
        "cms-form-panel",
        {
          attrs: {
            "submit-button": "Opslaan",
            "cancel-button": true,
            submitting: _vm.submitting,
          },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Referentie",
              name: "reference",
              "data-vv-as": "Referentie",
              error: _vm.error("reference"),
            },
            model: {
              value: _vm.pendingRepair.reference,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingRepair,
                  "reference",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingRepair.reference",
            },
          }),
          _c("cms-form-date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Einddatum",
              name: "endDate",
              input: "true",
              options: { disableMobile: true },
              "data-vv-as": "Einddatum",
              error: _vm.error("endDate"),
            },
            model: {
              value: _vm.pendingRepair.endDate,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingRepair,
                  "endDate",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingRepair.endDate",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }